import { updateStatusEndpoint } from '../enums/endpoints';
import { httpClient } from './httpClient';

export const updateStatusService = (
  selectedStatus: string,
  selectedRows: any,
  setUpdateStatusWindow: React.Dispatch<React.SetStateAction<boolean>>,
  setSuccessWindow: any,
  setFailedWindow: any,
  successWindow: any,
  failedWindow: any,
  setSelectedRows: any,
  setSelectedStatus: React.Dispatch<React.SetStateAction<string>>,
  setSelectedRowsWithPage?: any,
  selectedRowsWithPage?: any,
  setUpdateStatus:any=()=>{},
  updateStatus:any=false
) => {
  const selectedChargers = (
    selectedRows?.length === 0
      ? selectedRowsWithPage[0]?.undefined
      : selectedRows
  )?.map((item: any) => item?.chargerId);
  const payload = {
    chargerId: [...selectedChargers],
    status: selectedStatus,
  };
  return httpClient
    .put(updateStatusEndpoint, payload)
    .then((res: any) => {
      if (res) {
        setUpdateStatusWindow(false);
        if (!res?.isError) {
          setSuccessWindow({
            ...successWindow,
            status: true,
            message: res?.message,
          });
          setUpdateStatus(!updateStatus)
          setSelectedStatus('');
          setSelectedRows([]);
          setSelectedRowsWithPage([]);
        }
      }
    })
    .catch((e: any) => {
      setFailedWindow({
        ...failedWindow,
        status: true,
        message: e?.response?.data?.Message,
      });
      return e.message;
    });
};
